import { useDispatch } from "react-redux";
import { setShowFeedback } from "../redux/slices/UserSlice";

export default function DownloadCancelPopup({
    percentDownloaded,
    close,
    cancel,
    onConfirmCancel,
    onRejectCancel,
    showCancelConfirm,
    buildingZip,
}) {
    const dispatch = useDispatch();
    return (
        <>
            {+percentDownloaded === 100 ? (
                <div
                    className="preferences-options__popup download-options__popup complete"
                    style={{ display: "block" }}
                >
                    <div
                        onClick={close}
                        className="page-controller-tooltip-close"
                    >
                        <img
                            src="/assets/images/close-btn-tooltip.svg"
                            alt="Close"
                        />
                    </div>
                    <h3>
                        {/* Generating…<span>100%</span> */}
                        {buildingZip
                            ? "Please wait building zip..."
                            : "Completed!"}
                    </h3>
                    <div className="download-progress-bar">
                        <span style={{ width: "100%" }}></span>
                    </div>
                    <p>
                        Your custom jersey variations are now ready to print. 🎽
                    </p>
                    <p>
                        Thank you for using Teedex to simplify your design
                        process!
                    </p>
                    <button
                        className="cancel-button feedback-button"
                        onClick={() => dispatch(setShowFeedback(true))}
                    >
                        <img
                            src="/assets/images/feedback-popup-icn.svg"
                            alt="Down icon"
                        />
                        Leave Feedback
                    </button>
                </div>
            ) : !showCancelConfirm ? (
                <div
                    className="preferences-options__popup download-options__popup"
                    style={{ display: "block" }}
                >
                    <div
                        onClick={close}
                        className="page-controller-tooltip-close"
                    >
                        <img
                            src="/assets/images/close-btn-tooltip.svg"
                            alt="Close"
                        />
                    </div>
                    <h3>
                        Generating…
                    </h3>
                    <div className="download-progress-bar">
                        <span style={{ width: "100%" }}></span>
                    </div>
                    <p>
                        We’re processing all variations and creating
                        high-quality files for download.
                    </p>
                    <p>
                        This may take a few moments depending on the number of
                        designs and your internet speed.
                    </p>
                    <h5>⚡ Teedex Tip</h5>
                    <p>Keep this tab open for a smooth experience.</p>
                    <button onClick={cancel} className="cancel-button">
                        <img
                            src="/assets/images/cancle-icn.svg"
                            alt="Down icon"
                        />
                        Cancel Download
                    </button>
                </div>
            ) : (
                <div
                    className="preferences-options__popup download-options__popup"
                    style={{ display: "block" }}
                >
                    <div
                        onClick={close}
                        className="page-controller-tooltip-close"
                    >
                        <img
                            src="/assets/images/close-btn-tooltip.svg"
                            alt="Close"
                        />
                    </div>
                    <h3>
                        Generating…
                    </h3>
                    <div className="download-progress-bar">
                        <span style={{ width: `100%` }}></span>
                    </div>
                    <p>
                        We’re processing all variations and creating
                        high-quality files for download.
                    </p>
                    <h6>Are you sure you want to cancel?</h6>
                    <div className="button-groups">
                        <button
                            className="button-group-no"
                            onClick={onRejectCancel}
                        >
                            No
                        </button>
                        <button
                            className="button-group-yes"
                            onClick={onConfirmCancel}
                        >
                            Yes
                        </button>
                    </div>
                </div>
            )}
        </>
    );
}
